import React, { type InputHTMLAttributes, useCallback, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as CopyIcon } from '@pkg/assets/icons/v2/crypto-input-copy.svg';
import { useAppDispatch } from '@pkg/hooks';

import { copyToClipboard } from '@app/helpers';
import { addNotification } from '@app/store/actions/notification';

interface YatFloatingInputProps extends InputHTMLAttributes<HTMLInputElement> {
    classes?: string;
    label?: string;
}

const YatFloatingInput = ({ classes, label, ...props }: YatFloatingInputProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation(['words']);

    const copyValue = useCallback(() => {
        if (props.value) {
            copyToClipboard(props.value.toString());
            dispatch(
                addNotification({
                    message: t('copied'),
                    severity: 'info',
                }),
            );
        }
    }, [dispatch, props.value, t]);

    const classNames = useMemo(() => {
        let classNames = 'yat-floating-form__input';

        if (classes) classNames += ` ${classes}`;

        return classNames;
    }, [classes]);

    return (
        <div className="yat-floating-form">
            <label className="yat-floating-form__label">{label}</label>
            <input className={classNames} value={props.value} placeholder={props.placeholder} {...props} />
            <span className="yat-floating-form__action" onClick={copyValue}>
                <CopyIcon />
            </span>
        </div>
    );
};

export default YatFloatingInput;
